import { useState, useEffect } from 'react';

const Dashboard = ({tournament, teamsData}) => {
    const [activeTournament, setActiveTournament] = useState({});
    const [pools, setPools] = useState([]);
    const [games, setGames] = useState([]);
    const [nextActiveGames, setNextActiveGames] = useState([]);
    const [tieBreakerMessage, setTieBreakerMessage] = useState('');

    useEffect(() => {
        setActiveTournament(tournament);
        const pools = tournament.metadata[0]?.Pools || [];
        const games = tournament.metadata[1]?.Games || [];
    
        winVsLoss(pools, games);
    }, [ ]);

    // WeightedScore calculation scenarios
    const winVsLoss = (pools, games) => {
        const teamScores = {};
        const points = {};

        games.forEach((game) => {
            const homeTeam = getTeamInPoolById(pools, game.HomeTeamId, teamsData);
            const awayTeam = getTeamInPoolById(pools, game.AwayTeamId, teamsData);
        
            if (homeTeam && awayTeam) {
                if (game.HomeScore > game.AwayScore) {
                    teamScores[homeTeam.TeamId] = (teamScores[homeTeam.TeamId] || 0) + 1000;
                    points[homeTeam.TeamId] = (points[homeTeam.TeamId] || 0) + 2;
                } else if (game.AwayScore > game.HomeScore) {
                    teamScores[awayTeam.TeamId] = (teamScores[awayTeam.TeamId] || 0) + 1000;
                    points[awayTeam.TeamId] = (points[awayTeam.TeamId] || 0) + 2;
                } else {
                    teamScores[homeTeam.TeamId] = (teamScores[homeTeam.TeamId] || 0) + 100;
                    teamScores[awayTeam.TeamId] = (teamScores[awayTeam.TeamId] || 0) + 100;
                    points[homeTeam.TeamId] = (points[homeTeam.TeamId] || 0) + 1;
                    points[awayTeam.TeamId] = (points[awayTeam.TeamId] || 0) + 1;
                }
            }
        });
    
        // Update state with new scores
        const updatedPools = pools.map((pool) => ({
            ...pool,
            Teams: pool.Teams.map((team) => ({
                ...team,
                WeightedScore: teamScores[team.TeamId] || 0,
                TotalPoints: points[team.TeamId] || 0, // TODO: Need to figure this out
            })).sort((a, b) => b.WeightedScore - a.WeightedScore), // Sort by WeightedScore in descending order
        }));

        setPools(updatedPools);
        setGames(games);

        tieBreakerMethod();
    }

    const headToHead = () => {
        // TODO
        setTieBreakerMessage('Head-to-Head')
    }
    const pointsAgainst = () => {
        // TODO
        setTieBreakerMessage('Points Against')

    }
    const pointsFor = () => {
        // TODO
        setTieBreakerMessage('Points For')

    }
    // end WeightedScore scenarios
    
    // Helper functions
    const getTeamInPoolById = (pools, teamId) => {
        return pools.flatMap((pool) => pool.Teams).find((team) => team.TeamId === teamId);
    }

    const getTeamById = (id) => { return teamsData.Teams.filter(item => item.id === id).map(team => team.Name)};

    const tieBreakerMethod = () => {
        headToHead();
    }
    // end Helper functions

    return (
        <div>
        <div className='mb-4'><span>Showing current tournament:</span> <strong>{ activeTournament.Name }</strong></div>
        <div id='upcoming' className='mb-5'>
            <h2 className='mb-4'>Upcoming</h2>
            {/* <>
                { nextGamesData.slice(0,2).map(game => (
                        <div className='d-flex justify-content-between flex-wrap border py-3'>
                        <div className='d-flex justify-content-between flex-fill px-3'>
                            <div className='d-flex justify-content-start justify-content-sm-end flex-fill'><span className='me-3'>[logo]</span>{ getTeamById(game.AwayTeamId) }<small className='text-muted font-size-xs'>Away</small></div> 
                            <div className='mx-5'>v</div>
                            <div className='d-flex justify-content-start justify-content-sm-end flex-fill'><span className='me-3'>[logo]</span>{ getTeamById(game.HomeTeamId) }<small className='text-muted'>Home</small></div>
                            {/* TODO: maintenance needs 3 entries */}
                        {/* </div>
                        <div className='d-flex flex-fill justify-content-start justify-content-sm-end px-3'>{ game.GameStartDate }</div>
                    </div>
                )) }
            </> */}
        </div>
        <hr />
            <div id="pools" className='my-5'>
                <h2 className='mb-4'>Pools</h2>
                <div className='d-flex flex-wrap gap-3'>
                    { pools.map((pool) => (
                    <div className='d-flex justify-content-between table-responsive table-bordered flex-fill'>
                        <table className='table'>
                            <thead>
                                <tr><th className='text-nowrap p-2'>Pool { pool.id }</th><th className='text-nowrap p-2'>Points</th></tr>
                            </thead>
                            <tbody>
                                {pool.Teams.map((team) => (
                                    <tr key={ team.TeamId }>
                                    <td>{ getTeamById(team.TeamId) }<br /><small className='text-muted'><em>Tiebreaker: { tieBreakerMessage }</em></small></td>
                                    <td>{ team.TotalPoints }</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
